import { Box, Text } from '@factorialco/deprecated-design-system'
import type { TeamDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import TeamList from './List'

interface Props {
  team: TeamDetailFragment
  readonly?: boolean
  canSeeJobCatalog: boolean
  canSeeJobCatalogTree: boolean
  canSeeJobTitle: boolean
  hasLegacyJobCatalog: boolean
  hasDevJobCatalogTree: boolean
  canCreateJob: boolean
}

const Members = ({
  team,
  readonly,
  canSeeJobCatalog,
  canSeeJobCatalogTree,
  canSeeJobTitle,
  hasLegacyJobCatalog,
  hasDevJobCatalogTree,
  canCreateJob,
}: Props) => {
  return (
    <>
      <Box paddingBottom="s16">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t('employees.common.team_members')}
        </Text.Normal>
      </Box>
      <TeamList
        team={team}
        readonly={readonly}
        canSeeJobCatalog={canSeeJobCatalog}
        canSeeJobCatalogTree={canSeeJobCatalogTree}
        canSeeJobTitle={canSeeJobTitle}
        hasLegacyJobCatalog={hasLegacyJobCatalog}
        hasDevJobCatalogTree={hasDevJobCatalogTree}
        canCreateJob={canCreateJob}
      />
    </>
  )
}

export default Members
